import {Pipe, PipeTransform} from '@angular/core';
import {Router} from '@angular/router';

@Pipe({
  name: 'wpAnchorLinksUrlFix',
})
export class AnchorLinksUrlFixPipe implements PipeTransform {
  constructor(
    private router: Router
  ) {
  }

  transform(htmlContent: string): string {
    if (htmlContent != null) {
      const url = this.router.url.split('#')[0];
      const regex: RegExp = new RegExp(`href="#([^"]+)"`, 'g');
      htmlContent = htmlContent.replace(regex, `href="${url}#$1"`);
    }
    return htmlContent;
  }
}
